import * as Sentry from "@sentry/react";
import { useEffect, type FC } from "react";
import { useRouteError } from "react-router-dom";

import { ErrorState } from "./ErrorState";

/** A route's `errorElement`: the fault is reported and the page around it stays. */
export const RouteErrorPage: FC = () => {
  const error = useRouteError();
  useEffect(() => {
    Sentry.captureException(error, { tags: { boundary: "route" } });
  }, [error]);
  return (
    <ErrorState
      title="This Page Could Not Load"
      message="Something on this page failed to display. It was reported; reload to try again."
      buttonCta="Reload"
      minH="100%"
    />
  );
};

export default RouteErrorPage;
